import React, { useMemo } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowRight, Check, ShieldCheck } from 'lucide-react';
import { services, nav } from '../mock';

const ServiceDetail = () => {
  const { slug } = useParams();
  const svc = services[slug];
  const relatedServices = useMemo(
    () => nav.services.filter(s => s.slug !== slug),
    [slug]
  );
  if (!svc) return <Navigate to="/services" replace />;

  return (
    <div className="fade-in">
      <section className="hero-gradient border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 py-20">
          <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4">
            <Link to="/services" className="hover:text-[#2E75B6]">Services</Link>
            <span className="mx-2 text-slate-400">/</span>
            <span className="text-slate-600">{svc.title}</span>
          </div>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1F3864] max-w-4xl">{svc.title}</h1>
          <p className="mt-5 text-[18px] text-slate-700 max-w-3xl">{svc.hero}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-8 space-y-6 text-[16.5px] leading-[1.8] text-slate-700">
            {svc.body.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
            {svc.sections.map((sec) => (
              <div key={sec.title} className="mt-10">
                <h3 className="font-serif-display text-2xl text-[#1F3864] mb-4">{sec.title}</h3>
                <ul className="space-y-2.5">
                  {sec.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3">
                      <Check size={18} className="mt-1 text-[#2E75B6] flex-shrink-0" strokeWidth={2} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="pt-10">
              <Link to="/contact" className="inline-flex items-center gap-2 bg-[#1F3864] text-white text-[15px] font-medium px-6 py-3.5 rounded-sm hover:bg-[#17294a] transition-colors">
                Inquire About This Service <ArrowRight size={16} />
              </Link>
            </div>
          </div>
          <aside className="md:col-span-4">
            <div className="sticky top-24 border border-slate-200 rounded-sm p-6 bg-slate-50">
              <div className="flex items-center gap-2 text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4"><ShieldCheck size={14} /> Related Services</div>
              <ul className="space-y-2">
                {relatedServices.map(s => (
                  <li key={s.slug}>
                    <Link to={`/services/${s.slug}`} className="block text-[14.5px] text-slate-700 hover:text-[#1F3864] py-1.5 border-b border-slate-200 last:border-0">
                      {s.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
